import { useIntl } from 'react-intl';

import { formatMoney } from '@/components/driveToStore/common/helpers/formatters';

import type { BaseCurrencyInterface } from 'sonata-static-storage/lib/schemas/baseCurrency/baseCurrency.schema';

import './aggregatedTiles.scss';

type Props = {
  advertiserCount: number;
  baseCurrency: BaseCurrencyInterface;
  budget: number;
  campaignCount: number;
  lineItemCount: number;
  pricingTypesCount: number;
};

function padValue(value: number): string {
  return value < 10 ? `0${value}` : value.toString();
}

export default function AggregatedTiles({
  advertiserCount,
  baseCurrency,
  budget,
  campaignCount,
  lineItemCount,
  pricingTypesCount
}: Readonly<Props>) {
  const { formatMessage } = useIntl();

  return (
    <div className="aggregatedTiles">
      <div className="aggregatedTiles__tile" id="aggregatedTiles-lineItems">
        <i className="fa-solid fa-list aggregatedTiles__tileIcon" />
        <div className="aggregatedTiles__tileContent">
          <span className="aggregatedTiles__tileValue">{padValue(lineItemCount)}</span>
          <span className="aggregatedTiles__tileLabel">
            {formatMessage({
              defaultMessage: 'Line Items',
              id: 'driveToStore.aggregatedReport.header.tiles.lineItems'
            })}
          </span>
        </div>
      </div>
      <div className="aggregatedTiles__tile" id="aggregatedTiles-advertisers">
        <i className="fa-solid fa-volume aggregatedTiles__tileIcon" />
        <div className="aggregatedTiles__tileContent">
          <span className="aggregatedTiles__tileValue">{padValue(advertiserCount)}</span>
          <span className="aggregatedTiles__tileLabel">
            {formatMessage({
              defaultMessage: 'Advertisers',
              id: 'driveToStore.aggregatedReport.header.tiles.advertisers'
            })}
          </span>
        </div>
      </div>
      <div className="aggregatedTiles__tile" id="aggregatedTiles-campaigns">
        <i className="fa-regular fa-folder aggregatedTiles__tileIcon" />
        <div className="aggregatedTiles__tileContent">
          <span className="aggregatedTiles__tileValue">{padValue(campaignCount)}</span>
          <span className="aggregatedTiles__tileLabel">
            {formatMessage({
              defaultMessage: 'Campaigns',
              id: 'driveToStore.aggregatedReport.header.tiles.campaigns'
            })}
          </span>
        </div>
      </div>
      <div className="aggregatedTiles__tile" id="aggregatedTiles-pricingTypes">
        <i className="fa-regular fa-tag aggregatedTiles__tileIcon" />
        <div className="aggregatedTiles__tileContent">
          <span className="aggregatedTiles__tileValue">{padValue(pricingTypesCount)}</span>
          <span className="aggregatedTiles__tileLabel">
            {formatMessage({
              defaultMessage: 'Pricing types',
              id: 'driveToStore.aggregatedReport.header.tiles.pricingTypes'
            })}
          </span>
        </div>
      </div>
      <div className="aggregatedTiles__tile" id="aggregatedTiles-budget">
        <i className="fa-regular fa-coins aggregatedTiles__tileIcon" />
        <div className="aggregatedTiles__tileContent">
          <span className="aggregatedTiles__tileValue">{formatMoney(budget, baseCurrency)}</span>
          <span className="aggregatedTiles__tileLabel">
            {formatMessage({
              defaultMessage: 'Total Budget',
              id: 'driveToStore.aggregatedReport.header.tiles.totalBudget'
            })}
          </span>
        </div>
      </div>
    </div>
  );
}
